var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIdeaHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.1247C17.5228 20.1247 22 15.8341 22 10.5413C22 5.24861 17.5228 0.958008 12 0.958008C6.47715 0.958008 2 5.24861 2 10.5413C2 15.8341 6.47715 20.1247 12 20.1247Z",
    fill: "#FFF59D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4995 10.5419C18.4995 6.85233 15.1995 3.92941 11.2495 4.36066C8.24947 4.69608 5.84947 6.99608 5.54947 9.87108C5.29947 12.0752 6.24947 14.0398 7.84947 15.2857C8.54947 15.8607 8.99947 16.6752 8.99947 17.5857V17.7294H14.9995V17.6815C14.9995 16.819 15.3995 15.9565 16.0995 15.3815C17.5495 14.2315 18.4995 12.5065 18.4995 10.5419Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3008 9.67962L13.8008 8.72129C13.6508 8.62546 13.4008 8.62546 13.2508 8.72129L12.0008 9.48795L10.8008 8.72129C10.6508 8.62546 10.4008 8.62546 10.2508 8.72129L8.75078 9.67962C8.65078 9.77546 8.55078 9.87129 8.55078 10.015C8.55078 10.1588 8.55078 10.3025 8.65078 10.3984L10.5508 12.6505V17.7296H11.5508V12.4588C11.5508 12.363 11.5008 12.2671 11.4508 12.1713L9.80078 10.2067L10.5508 9.72754L11.7508 10.4942C11.9008 10.59 12.1508 10.59 12.3008 10.4942L13.5008 9.72754L14.2508 10.2067L12.6008 12.1713C12.5508 12.2671 12.5008 12.363 12.5008 12.4588V17.7296H13.5008V12.6505L15.4008 10.3984C15.5008 10.3025 15.5508 10.1588 15.5008 10.015C15.4508 9.87129 15.4008 9.72754 15.3008 9.67962Z",
    fill: "#FFF59D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5205C12.8284 22.5205 13.5 21.8769 13.5 21.083C13.5 20.2891 12.8284 19.6455 12 19.6455C11.1716 19.6455 10.5 20.2891 10.5 21.083C10.5 21.8769 11.1716 22.5205 12 22.5205Z",
    fill: "#5C6BC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.5625H11C9.9 21.5625 9 20.7 9 19.6458V17.25H15V19.6458C15 20.7 14.1 21.5625 13 21.5625Z",
    fill: "#9FA8DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.6462L9.2 20.4128C9.35 20.7482 9.65 21.0837 10 21.2753L14.7 20.6524C14.9 20.3649 15 20.0295 15 19.6462ZM9 18.5441V19.5024L15 18.6878V17.7295L9 18.5441Z",
    fill: "#5C6BC0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaHint);
export default __webpack_public_path__ + "static/media/ideaHint.92109e36cb5a56e42d0c3452f96a0473.svg";
export { ForwardRef as ReactComponent };